import { render, staticRenderFns } from "./DepartmentGroupButtonSelectorDialog.vue?vue&type=template&id=2ce6cde0&scoped=true&"
import script from "./DepartmentGroupButtonSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./DepartmentGroupButtonSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentGroupButtonSelectorDialog.vue?vue&type=style&index=0&id=2ce6cde0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6cde0",
  null
  
)

export default component.exports